<template>
	<div v-if="viewLoaded" class="offer-read-only">
		<div v-if="!offerData.sendDate" class="d-none print-only"><h1>(Wydruk próbny!)</h1></div>

		<v-layout justify-end mr-3 class="no-print" v-if="numberOfModules <= 1">
			<v-btn @click="printBudget()">Wydrukuj budżet</v-btn>
			<v-btn @click="printSchedule()">Wydrukuj harmonogram</v-btn>
			<v-btn @click="printActivities()">Wydrukuj opis działań</v-btn>
			<v-btn @click="exportTables(1, false)">Eksportuj tabele finansowe</v-btn>
			<v-btn @click="print">Wydrukuj ofertę</v-btn>
		</v-layout>
		<div v-if="numberOfModules > 1">
			<v-layout justify-end mr-3 class="no-print" v-for="i in numberOfModules" v-bind:key="i">
				<v-btn @click="printBudgetModule(i)">Wydrukuj budżet (moduł {{i}})</v-btn>
				<v-btn @click="printScheduleModule(i)">Wydrukuj harmonogram (moduł {{i}})</v-btn>
				<v-btn @click="printActivitiesModule(i)">Wydrukuj opis działań (moduł {{i}})</v-btn>
				<v-btn @click="exportTables(i, true)">Eksportuj tabele (moduł {{i}})</v-btn>
				<v-btn @click="printModule(i)">Wydrukuj ofertę (moduł {{i}})</v-btn>
			</v-layout>
		</div>
		<h3 v-if="currentModuleForPrint" class="text-xs-center">
			M {{currentModuleForPrint}}
			<span v-if="!offerData.sendDate" class="d-none print-only"><h1>(Wydruk próbny!)</h1></span>
		</h3>
		<offer-name
			:readonly="true"
			v-model="offerData.title"
		></offer-name>

		<ContestOfferSummary
			:contest-configuration="contestConfiguration"
			:offerData="offerData"/>

		<offer-english-name-read-only-view
			v-model="offerData.englishTitle"
			ref="englishName"
		></offer-english-name-read-only-view>

		<priority-tree-read-only-view
			v-model="offerData.prioritiesData"
			:show-print-info="!offerData.sendDate"
			:contest-id="contestData.id"
			ref="priorityTree"
		></priority-tree-read-only-view>

		<choose-funding
			class="funding-table"
			:readonly="true"
			ref="funding"
			:contest-id="contestData.id"
			:input="offerData.prioritiesData"
			:countries-changed.sync="countriesChanged"
			v-model="offerData.financesData"
			:show-print-info="!offerData.sendDate"
		></choose-funding>

		<choose-d-a-c
			v-if="contestConfiguration.dacCodesEnabled"
			:readonly="true"
			:contest-id="contestData.id"
			type="PUBLIC_CONTEST"
			ref="chooseDac"
			v-model="offerData.dacCodes"
			:show-print-info="!offerData.sendDate"
		></choose-d-a-c>

		<offer-other-bidders
			class="offer-other-bidders"
			v-if="offerData.mutualOffer"
			:readonly="true"
			v-model="offerData.otherBiddersId"
			:mutual-offer="offerData.mutualOffer"
			@change="(val) => offerData.mutualOffer = val"
		></offer-other-bidders>

		<div class="read-only-offer-modules">
			<div v-for="i in (numberOfModules !== 0 ? numberOfModules : 1)" :key="i"
				:class="resolvePrintClassFormModule(i)">
				<choose-start-end-read-only-view
					v-model="offerData.stepsConstantData[i - 1].dates"
					ref="startEnd"
					:number-of-modules="numberOfModules"
					:module-number="i"
					:show-print-info="!offerData.sendDate"
				></choose-start-end-read-only-view>

				<choose-volunteers-read-only-view
					v-if="contestConfiguration.volunteersAvailable"
					v-model="offerData.stepsConstantData[i - 1].volunteers"
					:volunteers-required="contestConfiguration.volunteersRequired"
					:global-init="offerData.stepsConstantData[i - 1].globalInitiative"
					:global-init-description="offerData.stepsConstantData[i - 1].globalInitiativeDescription"
					ref="volunteers"
					:show-print-info="!offerData.sendDate"
				></choose-volunteers-read-only-view>

				<choose-actions-read-only-view
					:contest-id="contestData.id"
					v-model="offerData.stepsConstantData[i - 1].actionsData"
					ref="actions"
					:min-start="offerData.stepsConstantData[i - 1].dates.start"
					:max-end="offerData.stepsConstantData[i - 1].dates.end"
					:number-of-modules="numberOfModules"
					:module-number="i"
					:show-print-info="!offerData.sendDate"
				></choose-actions-read-only-view>

				<choose-geographical-location-read-only-view
					v-model="offerData.stepsConstantData[i - 1].locations"
					ref="locations"
					:show-print-info="!offerData.sendDate"
				></choose-geographical-location-read-only-view>
				<costs-calculated-table
					:actions="offerData.stepsConstantData[i - 1].actionsData"
					:administrative="offerData.stepsConstantData[i - 1].administrativeCosts"
					:number-of-modules="numberOfModules"
					:module-number="i"
					:ref="'costsCalculatedTable-' + i"
					:show-print-info="!offerData.sendDate"
				/>
				<costs-summary-table
					:readonly="true"
					:offer-configuration="contestConfiguration"
					:main-country-id="offerData.prioritiesData.mainCountryId"
					:main-bidder-id="offerData.mainBidderId"
					:contest-id="contestData.id"
					:number-of-modules="numberOfModules"
					:module-number="i"
					:ref="'costsSummaryTable-' + i"
					:show-print-info="!offerData.sendDate"
					:offer-data-id="offerData.id"
					:offer-data="offerData"
				></costs-summary-table>

				<bidder-fundings-table
					class="mt-4 read-only-costs-sharing"
					:readonly="true"
					:actions="offerData.stepsConstantData[i - 1].actionsData"
					:administrative="offerData.stepsConstantData[i - 1].administrativeCosts"
					:fundings="offerData.stepsConstantData[i - 1].bidderFundings"
					:mutual="offerData.mutualOffer"
					ref="bidderFundings"
					:show-print-info="!offerData.sendDate"
				></bidder-fundings-table>

				<contest-offer-timetable
					class="d-none print-only mt-2 mb-2"
					:readonly="true"
					:actions="timetableActions(i)"
					:show-print-info="!offerData.sendDate"
				></contest-offer-timetable>

				<div class="read-only-offer-basic-section-generic">
					<div v-for="(section, index) in moduleGenericMap(i)" v-bind:key="index">
						<vue-form-generator
							:disabled="true"
							:name="'module-'.concat(i).concat('-generator-').concat(index)"
							:model="section.model"
							:schema="section.schema"
						/>
					</div>
				</div>
			</div>
		</div>
		
		<div class="read-only-offer-basic-section-generic">
			<div v-for="(section, index) in persistentGenericMap" v-bind:key="index">
				<vue-form-generator
					class="read-only-offer-view-form"
					:disabled="true"
					:name="'persistentGenerator-'.concat(index)"
					:model="section.model"
					:schema="section.schema"
				/>
			</div>
		</div>
		<offer-signatures
			:count="offerData.otherBiddersId.length + 1"
		/>
		<div v-if="!offerData.sendDate"><h1>Wydruk próbny !</h1></div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import VueFormGenerator from "vue-form-generator";
	import OfferName from "./components/OfferName";
	import ChooseFunding from "./components/ChooseFunding";
	import CostsSummaryTable from "./components/CostsSummaryTable";
	import BidderFundingsTable from "./components/BidderFundingsTable";
	import OfferOtherBidders from "./components/OfferOtherBidders";
	import {Api} from "@/api";
	import ChooseDAC from "./components/ChooseDAC";
	import ContestOfferTimetable from "./components/ContestOfferTimetable";
	import {getIdByLegalFormName} from "@/utils/LegalFormDictionary";
	import {getSectorByLegalFormId} from "@/utils/LegalFormSectorDictionary";
	import ContestOfferSummary from "./components/ContestOfferSummaryView";
	import CostsCalculatedTable from "./components/CostsCalculatedTableComponents/CostsCalculatedTable";
	import OfferSignatures from "./OfferSignatures";
	import {Dates} from "@/utils/Dates";
	import {Files} from "@/utils/Files";
	import {CostsUtils} from "@/utils/CostsUtils";
	import {XlsExport} from "@/api/generated/XlsExport";
	import OfferEnglishNameReadOnlyView from "./components/ReadOnlyComponents/OfferEnglishNameReadOnlyView";
	import ChooseStartEndReadOnlyView from "./components/ReadOnlyComponents/ChooseStartEndReadOnlyView";
	import PriorityTreeReadOnlyView from "./components/ReadOnlyComponents/PriorityTreeReadOnlyView";
	import ChooseVolunteersReadOnlyView from "./components/ReadOnlyComponents/ChooseVolunteersReadOnlyView";
	import ChooseActionsReadOnlyView from "./components/ReadOnlyComponents/ChooseActionsReadOnlyView";
	import ChooseGeographicalLocationReadOnlyView
		from "./components/ReadOnlyComponents/ChooseGeographicalLocationReadOnlyView";

	Vue.use(VueFormGenerator);

	export default {
		name: "ContestReadOnlyOfferView",
		components: {
			ChooseGeographicalLocationReadOnlyView,
			ChooseActionsReadOnlyView,
			ChooseVolunteersReadOnlyView,
			PriorityTreeReadOnlyView,
			OfferEnglishNameReadOnlyView,
			OfferSignatures,
			CostsCalculatedTable,
			ContestOfferTimetable,
			ChooseDAC,
			OfferOtherBidders,
			ChooseFunding,
			OfferName,
			CostsSummaryTable,
			BidderFundingsTable,
			ChooseStartEndReadOnlyView,
			ContestOfferSummary,
		},

		mixins: [
			CostsUtils,
		],

		computed: {

			viewLoaded () {
				return this.offerDataLoaded && this.contestConfigurationLoaded;
			}
			,

			stepTitle () {
				return this.viewData.titles.allTitles[this.viewData.step - 1];
			},

			numberOfModules () {
				return this.contestConfiguration.numberOfModules;
			}
			,

			isFirstStep () {
				return this.viewData.step === 1;
			},

			isLastStep () {
				return this.viewData.step === this.totalNumberOfSteps;
			},

			totalNumberOfSteps () {
				if (this.isModuleOffer()) {
					return this.numberOfFirstNotModuleSteps
						+ this.numberOfModules * (this.numberOfConstFieldsModuleSteps + this.numberOfGenericModularSteps)
						+ this.numberOfGenericPersistentSteps + this.numberOfLastNotGenericSteps;
				} else {
					// oferty niemodulowe, traktujemy jakby byl jeden modul bez formularza generycznego powtarzanego dla wszystkich modulow
					return this.numberOfFirstNotModuleSteps
						+ this.numberOfConstFieldsModuleSteps + this.numberOfGenericPersistentSteps + this.numberOfLastNotGenericSteps;
				}
			}
			,

			numberOfFirstNotModuleSteps () {
				return this.viewData.titles.firstNotModuleStepTitles.length;
			}
			,

			numberOfConstFieldsModuleSteps () {
				return this.viewData.titles.moduleConstFieldSteps.length;
			}
			,


			numberOfGenericModularSteps () {
				if (this.contestConfiguration.moduleSchema) {
					return this.contestConfiguration.moduleSchema.sections.length;
				} else {
					return 0;
				}
			}
			,

			numberOfGenericPersistentSteps () {
				return this.contestConfiguration.persistentSchema.sections.length;
			}
			,

			numberOfLastNotGenericSteps () {
				return this.viewData.titles.lastNotGenericStepTitles.length;
			}
			,
			persistentGenericMap () {
				if (this.contestConfiguration.persistentSchema === null || this.offerData.genericModel === null) {
					return null;
				} else {
					let sectionsArray = [];
					for (let i = 0; i < this.contestConfiguration.persistentSchema.sections.length; i++) {
						if (!genericFormUtil.sectionShouldNotBeOnView(this.contestConfiguration.persistentSchema, i)) {
							sectionsArray.push(
								{
									schema: this.applyGenericPersistentForm(i),
									model: this.offerData.genericModel.sections[i].fields,
								},
							);
						}
					}
					return sectionsArray;
				}
			},
		},

		data () {
			return {
				countriesChanged: false,

				contestData: {
					id: this.$route.params.id,
				},

				// tutaj pakujemy dane z konfiguracji konkursu
				contestConfiguration: {
					numberOfModules: 0,
					moduleSchema: null,
					persistentSchema: null,
					firstPossibleOfferDate: "",
					lastPossibleOfferDate: "",
				},

				// tutaj pakujemy dane oferty
				offerData: {
					step: 1,
					id: this.$route.params.offerId,
					title: "",
					sendDate: this.$route.params.sendDate,
					englishTitle: "",
					legalForm: "",
					polishName: "",
					otherBiddersId: [],
					prioritiesData: {
						selected: [],
						extraCountries: [],
					},
					stepsConstantData: [],
					financesData: {
						countriesFundings: [],
						totalFundings: "",
					},
					dacCodes: [],
					moduleGenericModel: undefined,
					genericModel: undefined,
					mutualOffer: false,
				},

				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalBooleans: [],
				},

				viewData: {
					step: 1,
					showGenerator: false,
					titles: {
						firstNotModuleStepTitles: ["Podstawowe informacje", "Statystyka"], // w zaleznosci od ilosci tytulow oblicza sie ilosc poszczegolnych krokow...
						lastNotGenericStepTitles: ["Składanie oferty"],
						moduleConstFieldSteps: ["Ramy czasowe", "Działania programowe", "Koszty", "Podsumowanie kosztów", "Harmonogram"],
						allTitles: [],
					},
					sendOfferDialog: false,
					completeOfferDialog: false,
				},
				contestConfigurationLoaded: false,
				offerDataLoaded: false,
				currentModuleForPrint: parseInt(this.$route.params.module),
			};
		}
		,

		created () {
			this.loadData();
		}
		,

		methods: {

			async loadData () {
				await Api.syncGet(this, "/public-contest/offer-configuration?offerId=".concat(this.offerData.id), response => {
						this.initializeContestConfiguration(response);
						// inicjalizuje schematy generycznego formularza
						this.initializeGenericSchemas(response);
						// inicjalizujemy wartosci generycznego formularza w ofercie
						this.contestConfigurationLoaded = true;
					},
					errorResponse => this.$messagesBus.$emit("error", "Nie udało się wczytać konfiguracji oferty!", errorResponse),
				);
				// Pobranie danych oferty
				let path;
				if (this.$route.params.version) {
					path = "/offer/data-version?offerId=".concat(this.offerData.id).concat("&version=".concat(this.$route.params.version));
				} else {
					path = "/offer/data-readonly?offerId=".concat(this.offerData.id);
				}
				await Api.syncGet(
					this,
					path,
					response => {
						for (let field in response) {
							this.$set(this.offerData, field, response[field]);
						}
						this.contestConfiguration.numberOfModules = this.resolveNumberOfModules(response);
						this.initializeGenericModel(response);
						this.offerDataLoaded = true;
						this.initializeStepTitles();
						this.viewData.step = response.step;
					},
					errorResponse => this.$messagesBus.$emit("error", "Nie udało się wczytać oferty!", errorResponse),
				);
				if (!this.persistentGenericMap) return;
				this.persistentGenericMap.forEach(function (section, index) {
					genericFormUtil.addHeaderToFirstForm(
						"persistentGenerator-".concat(index.toString()),
						"<h2 style=\"margin-left: 20px; margin-top: 10px; page-break-after: avoid\">"
							+ this.contestConfiguration.persistentSchema.sections[index].name +
							(!this.offerData.sendDate ? "<span class=\"d-none print-only-inline\"> (Wydruk próbny!)</span>" : "") +
							"</h2>");
				}, this);
				for (let i = 1; i <= this.numberOfModules; ++i) {
					if (!this.moduleGenericMap(i)) continue;
					this.moduleGenericMap(i).forEach(function (section, index) {
						genericFormUtil.addHeaderToFirstForm(
							"module-".concat(i.toString()).concat("-generator-").concat(index.toString()),
							"<h2 style=\"margin-left: 20px; page-break-after: avoid\">" + this.getModuleSchemaTitle(index, i) +
								(!this.offerData.sendDate ? "<span class=\"d-none print-only-inline\"> (Wydruk próbny!)</span>" : "") +
								"</h2>",
						);
					}, this);
				}
			},

			resolvePrintClassFormModule (moduleNumber) {
				if (this.numberOfModules > 1 && this.currentModuleForPrint !== null && this.currentModuleForPrint !== moduleNumber) {
					return "no-print";
				}
			},

			moduleGenericMap (moduleNumber) {
				if (this.contestConfiguration.moduleSchema === null || this.offerData.moduleGenericModel === null) {
					return null;
				} else {
					let sectionsArray = [];
					for (let i = 0; i < this.contestConfiguration.moduleSchema.sections.length; i++) {
						if (!genericFormUtil.sectionShouldNotBeOnView(this.contestConfiguration.moduleSchema, i)) {
							sectionsArray.push(
								{
									schema: this.applyGenericModuleForm(i, moduleNumber),
									model: this.offerData.moduleGenericModel[moduleNumber].sections[i].fields,
								});
						}
					}
					return sectionsArray;
				}
			},

			timetableActions(moduleNumber) {
				const actions = JSON.parse(JSON.stringify(this.offerData.stepsConstantData[moduleNumber -1].actionsData));
				return actions.sort((a, b) => a.serialNumber - b.serialNumber);
			},

			initializeContestConfiguration (response) {
				this.contestConfiguration.moduleSchema = genericFormUtil.decodeSchema(response.moduleSchema);
				this.contestConfiguration.persistentSchema = genericFormUtil.decodeSchema(response.persistentSchema);
				this.contestConfiguration.firstPossibleOfferDate = response.firstPossibleOfferDate;
				this.contestConfiguration.lastPossibleOfferDate = response.lastPossibleOfferDate;
				this.contestConfiguration.volunteersAvailable = response.volunteersAvailable;
				this.contestConfiguration.volunteersRequired = response.volunteersRequired;
				this.contestConfiguration.modulePriceLimit = response.modulePriceLimit;
				this.contestConfiguration.dacCodesEnabled = response.dacCodesEnabled;
			},

			initializeGenericModel (response) {
				this.offerData.genericModel = this.getPersistentModel(response);
				this.offerData.moduleGenericModel = this.getModuleModel(response);
			}
			,

			getModuleModel (response) {
				if (this.isModuleOffer()) {
					let map = {};
					for (let i = 1; i <= this.numberOfModules; i++) {
						if (response.moduleGenericModel[i]) {
							map[i] = genericFormUtil.decodeSchema(response.moduleGenericModel[i]);
						} else {
							map[i] = genericFormUtil.buildModelFromSchema(this.contestConfiguration.moduleSchema);
						}
					}
					return map;
				}
				return null;
			}
			,

			getModuleSchemaTitle (index, moduleNumber) {
				return this.contestConfiguration.moduleSchema.sections[index].name.concat(
					this.numberOfModules > 1 ? " (Moduł " + moduleNumber + ")" : "",
				);
			}
			,

			changeCountries () {
				this.countriesChanged = true;
			}
			,

			getFormId (legalForm) {
				return getIdByLegalFormName(legalForm);
			}
			,

			getSector (legalFormId) {
				return getSectorByLegalFormId(legalFormId);
			}
			,

			getPersistentModel (response) {
				if (response.persistentGenericModel) {
					return genericFormUtil.decodeSchema(response.persistentGenericModel);
				}
				return genericFormUtil.buildModelFromSchema(this.contestConfiguration.persistentSchema);
			}
			,

			initializeGenericSchemas (response) {
				this.contestConfiguration.persistentSchema = this.getPersistentSchema(response);
				this.contestConfiguration.moduleSchema = this.getModuleSchema(response);
			}
			,

			initializeStepTitles () {
				this.viewData.titles.firstNotModuleStepTitles.forEach(title => {
					this.viewData.titles.allTitles.push(title);
				});
				if (this.isModuleOffer()) {
					for (let i = 0; i < this.numberOfModules; i++) {
						this.viewData.titles.moduleConstFieldSteps.forEach(title => {
							this.viewData.titles.allTitles.push(title);
						});
						for (let j = 0; j < this.numberOfGenericModularSteps; j++) {
							this.viewData.titles.allTitles.push(
								this.contestConfiguration.moduleSchema.sections[j].name.concat(" (Moduł " + (i + 1) + ")"));
						}
					}
				} else {
					this.viewData.titles.moduleConstFieldSteps.forEach(title => {
						this.viewData.titles.allTitles.push(title);
					});
					this.viewData.titles.allTitles.push();
				}

				for (let i = 0; i < this.numberOfGenericPersistentSteps; i++) {
					this.viewData.titles.allTitles.push(this.contestConfiguration.persistentSchema.sections[i].name);
				}
				this.viewData.titles.lastNotGenericStepTitles.forEach(title => {
					this.viewData.titles.allTitles.push(title);
				});

			}
			,

			resolveNumberOfModules (response) {
				// zwraca 0 w przypadku gdy nie jest to oferta modulowa, może też być 1 modul, wtedy zwraca 1 oraz n, wtedy n.
				return Object.keys(response.moduleGenericModel).length;
			}
			,

			getModuleSchema (response) {
				if (response.moduleSchema) {
					return genericFormUtil.decodeSchema(response.moduleSchema);
				}
				return null;
			}
			,

			getPersistentSchema (response) {
				return genericFormUtil.decodeSchema(response.persistentSchema);
			}
			,

			isModuleOffer () {
				return this.numberOfModules > 0;
			}
			,

			isConstFieldsFirstSteps () {
				let step = this.viewData.step;
				if (step <= this.numberOfFirstNotModuleSteps) {
					return true;
				}
			}
			,

			isConstFieldsModuleStep () {
				let step = this.viewData.step;
				// dla ofert modulowych
				if (this.isModuleOffer()) {
					for (let i = 0; i < this.numberOfModules; i++) {
						if ((step > this.numberOfFirstNotModuleSteps + i * (this.numberOfConstFieldsModuleSteps + this.numberOfGenericModularSteps))
							&& (step <= this.numberOfFirstNotModuleSteps + (i + 1) * this.numberOfConstFieldsModuleSteps + i * this.numberOfGenericModularSteps)) {
							return true;
						}
					}
					return false;
					// dla ofert niemodulowych
				} else {
					return (
						step > this.numberOfFirstNotModuleSteps &&
						step <=
						this.numberOfFirstNotModuleSteps +
						this.numberOfConstFieldsModuleSteps
					);
				}
			}
			,

			isGenericPersistentStep () {
				let step = this.viewData.step;
				return (step > this.totalNumberOfSteps - this.numberOfLastNotGenericSteps - this.numberOfGenericPersistentSteps && step <= this.totalNumberOfSteps - this.numberOfLastNotGenericSteps);
			}
			,

			isLastNotGenericSteps () {
				let step = this.viewData.step;
				return (step >= this.totalNumberOfSteps - this.numberOfLastNotGenericSteps && step <= this.totalNumberOfSteps);
			}
			,

			isGenericModuleStep () {
				let step = this.viewData.step;
				for (let i = 0; i < this.numberOfModules; i++) {
					if (
						step >
						this.numberOfFirstNotModuleSteps +
						(i + 1) * this.numberOfConstFieldsModuleSteps +
						i * this.numberOfGenericModularSteps &&
						step <=
						this.numberOfFirstNotModuleSteps +
						(i + 1) *
						(this.numberOfConstFieldsModuleSteps +
						this.numberOfGenericModularSteps)
					) {
						return true;
					}
				}
				return false;
			}
			,

			applyGenericPersistentForm (sectionIndex) {
				let sections = this.offerData.genericModel.sections;
				let schema = genericFormUtil.getSectionSchemaFromSchema(
					this.contestConfiguration.persistentSchema,
					sectionIndex,
					true,
				);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = sections[sectionIndex].fields;
					return genericFormUtil.filterSchemaByConditionalFieldsValue(
						schema,
						schemaValues,
					);
				} else {
					return schema;
				}
			},

			applyGenericModuleForm (sectionIndex, moduleNumber) {
				let sections = this.offerData.moduleGenericModel[moduleNumber].sections;
				let schema = genericFormUtil.getSectionSchemaFromSchema(
					this.contestConfiguration.moduleSchema,
					sectionIndex,
					true,
				);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = sections[sectionIndex].fields;
					return genericFormUtil.filterSchemaByConditionalFieldsValue(
						schema,
						schemaValues,
					);
				} else {
					return schema;
				}
			},

			resolveSectionIndexInPersistentSchema () {
				return this.numberOfGenericPersistentSteps - (this.totalNumberOfSteps - this.numberOfLastNotGenericSteps - this.viewData.step) - 1;
			},

			resolveSectionIndexInConstFieldModule () {
				let step = this.viewData.step;
				// dla ofert modulowych
				if (this.isModuleOffer()) {
					for (let i = 0; i < this.numberOfModules; i++) {
						if (
							step >
							this.numberOfFirstNotModuleSteps +
							i *
							(this.numberOfConstFieldsModuleSteps +
							this.numberOfGenericModularSteps) &&
							step <=
							this.numberOfFirstNotModuleSteps +
							(i + 1) * this.numberOfConstFieldsModuleSteps +
							i * this.numberOfGenericModularSteps
						) {
							return (
								step -
								(this.numberOfFirstNotModuleSteps +
								i *
								(this.numberOfConstFieldsModuleSteps +
								this.numberOfGenericModularSteps)) -
								1
							);
						}
					}
					// dla ofert niemodulowych
				} else {
					return step - this.numberOfFirstNotModuleSteps - 1;
				}
			}
			,

			resolveSectionIndexInFirstConstSteps () {
				return this.viewData.step - 1;
			},

			resolveSectionIndexInLastConstSteps () {
				return this.numberOfLastNotGenericSteps - (this.totalNumberOfSteps - this.viewData.step);
			},

			exportTables (module, manyModules) {
				XlsExport.postExportOfferTables(this, this.prepareExportData(module, manyModules, false, this.offerData.id), successResponse => {
						let filename = "egranty_export_" + Dates.methods.getFilenameTimestamp() + "_raport.xlsx";
						this.$messagesBus.$emit("success", "Eksport danych wykonano do pliku " + filename, successResponse);
						Files.methods.downloadBlobResponse(successResponse, filename);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Eksport nieudany", errorResponse);
					},
					{
						responseType: "blob",
					});
			},

			async print () {
				if (this.$route.params.version) {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferPrintUrl(
							this.contestData.id,
							this.offerData.id,
							this.$route.params.version),
						"oferta.pdf");
				} else {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferPrintUrl(
							this.contestData.id,
							this.offerData.id),
						"oferta.pdf");
				}
			},

			async printModule (i) {
				if (this.$route.params.version) {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferPrintUrl(
							this.contestData.id,
							this.offerData.id,
							i,
							this.$route.params.version),
						"oferta_mod_".concat(i).concat(".pdf"));
				} else {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferPrintUrl(
							this.contestData.id,
							this.offerData.id,
							i),
						"oferta_mod_".concat(i).concat(".pdf"));
				}
			},

			async printBudget () {
				if (this.$route.params.version) {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferBudgetPrintUrl(
							this.contestData.id,
							this.offerData.id,
							this.$route.params.version),
						"budzet.pdf");
				} else {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferBudgetPrintUrl(
							this.contestData.id,
							this.offerData.id),
						"budzet.pdf");
				}
			},

			async printBudgetModule (i) {
				if (this.$route.params.version) {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferBudgetPrintUrl(
							this.contestData.id,
							this.offerData.id,
							i,
							this.$route.params.version),
						"budzet_mod_".concat(i).concat(".pdf"));
				} else {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferBudgetPrintUrl(
							this.contestData.id,
							this.offerData.id,
							i),
						"budzet_mod_".concat(i).concat(".pdf"));
				}
			},

			async printSchedule () {
				if (this.$route.params.version) {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferTimetablePrintUrl(
							this.contestData.id,
							this.offerData.id,
							this.$route.params.version),
						"harmonogram.pdf");
				} else {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferTimetablePrintUrl(
							this.contestData.id,
							this.offerData.id),
						"harmonogram.pdf");
				}
			},

			async printScheduleModule (i) {
				if (this.$route.params.version) {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferTimetablePrintUrl(
							this.contestData.id,
							this.offerData.id,
							i,
							this.$route.params.version),
						"harmonogram_mod_".concat(i).concat(".pdf"));
				} else {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferTimetablePrintUrl(
							this.contestData.id,
							this.offerData.id,
							i),
						"harmonogram_mod_".concat(i).concat(".pdf"));
				}
			},

			async printActivities () {
				if (this.$route.params.version) {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferActivitiesPrintUrl(
							this.contestData.id,
							this.offerData.id,
							this.$route.params.version),
						"działania.pdf");
				} else {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferActivitiesPrintUrl(
							this.contestData.id,
							this.offerData.id),
						"działania.pdf");
				}
			},

			async printActivitiesModule (i) {
				if (this.$route.params.version) {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferActivitiesPrintUrl(
							this.contestData.id,
							this.offerData.id,
							i,
							this.$route.params.version),
						"działania_mod_".concat(i).concat(".pdf"));
				} else {
					await Files.methods.downloadFileAsBlob(
						this,
						Files.methods.getOfferActivitiesPrintUrl(
							this.contestData.id,
							this.offerData.id,
							i),
						"działania_mod_".concat(i).concat(".pdf"));
				}
			},

		},
	};
</script>
<style>
	.vue-form-generator .field-checklist .listbox {
		max-height: inherit;
		margin-bottom: 10px;
	}

	.vue-form-generator .v-text-field__slot textarea {
		padding: 10px;
		color: #555;
	}

	.stepTitle {
		margin: 20px;
	}

	.div-for-print {
		display: none;
	}

	.field-wrap .container {
		padding: 0;
	}

	.field-wrap .container .layout:only-child {
		margin: 0;
	}

	.read-only-offer-basic-section-generic .vue-form-generator .field-switch .label:before,
	.read-only-offer-basic-section-generic .vue-form-generator .field-switch .label:after {
		color: #555;
		font-size: 13px;
		left: 0 !important;
		transform: translateY(50%);
		line-height: 16px;
	}

	.read-only-offer-basic-section-generic .vue-form-generator .field-switch input:checked ~ .label,
	.read-only-offer-basic-section-generic .vue-form-generator .field-switch .label {
		background: transparent;
		border: none;
		box-shadow: none;
		position: relative;
	}

	.read-only-offer-basic-section-generic .vue-form-generator .field-switch .field-wrap label span {
		padding: 0;
	}

	.read-only-offer-basic-section-generic .vue-form-generator .field-switch .field-wrap label {
		height: auto;
		min-height: 43px;
		display: block;
		color: #555;
		border: 1px solid #ccc;
		border-radius: 4px;
		width: 100%;
		padding: 10px;
		margin: 0 0 .4rem 0;
		cursor: default;
	}

	.form-group > label {
		font-weight: 700;
	}

	.form-group.field-checkbox > label {
		font-weight: 400;
	}

	.read-only-offer-basic-section-generic .vue-form-generator .form-group.field-switch {
		padding-bottom: 0;
	}

	.read-only-offer-basic-section-generic .vue-form-generator .field-switch input:checked ~ .handle,
	.read-only-offer-basic-section-generic .vue-form-generator .field-switch .handle {
		display: none;
	}

	@media print {
		.v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot textarea {
			display: none;
		}

		.div-for-print {
			white-space: pre-wrap;
			display: block;
			color: #555;
			border: 1px solid #ccc;
			border-radius: 4px;
			padding: 10px;
			width: 100%;
			min-height: 43px;
			font-size: 13px;
			line-height: 16px;
		}

		.no-print {
			display: none;
		}

		.print-only {
			display: block;
		}

		.form-group {
			display: block;
			page-break-inside: avoid;
			position:relative;
		}

		.form-group>label {
			display: table-cell;
			page-break-after: avoid;
		}
	}

	.theme--dark th,
	.theme--dark td {
		border: solid 1px white !important;
	}

	.vue-form-generator .form-group:not(:last-of-type) {
		margin-bottom: 0;
	}

	.vue-form-generator .form-group {
		padding-bottom: 0;
		padding-top: 0;
		margin-bottom: 1rem;
	}

	fieldset {
		padding-top: 9px;
	}

	.form-group.disabled.featured.field-input {
		margin-bottom: 12px;
	}

	.field-customTextArea .field-wrap .container .v-textarea {
		padding: 0;
		margin: 0;
	}

	.read-only-offer-basic-section-generic .vue-form-generator .field-switch input:checked ~ .label {
		background-color: transparent !important;
	}

	.offer-signature-table th,
	.offer-signature-table td {
		border: 2px groove rgb(192, 192, 192);
	}

	.form-group label > :first-child {
		display: inline;
	}

	.offer-read-only .vue-form-generator .field-wrap {
		display: block;
	}


	@media screen and (min-width: 960px) {
		.field-customTextArea .field-wrap .container {
			max-width: inherit;
		}
	}

</style>
